module.exports = __webpack_public_path__ + "img/icon-core1-1.d8a2df4e.png";